import { MockedRequest, RestHandler, rest } from "msw";

import { Estimate } from "types/Estimate";

import { generateTestEstimate } from "../../tests/data";

export const buildAcceptOfferResponse = (
  status: number,
  response: Estimate | null
): RestHandler<MockedRequest<Estimate | null>> => {
  return rest.post(`/client/:clientId/session/:sessionId/offer/accept`, (_, res, ctx) => {
    return res(ctx.status(status), ctx.json(response));
  });
};

export const buildDeclineOfferResponse = (
  status: number,
  response: Estimate | null
): RestHandler<MockedRequest<Estimate | null>> => {
  return rest.post(`/client/:clientId/session/:sessionId/offer/decline`, (_, res, ctx) => {
    return res(ctx.status(status), ctx.json(response));
  });
};

export const buildNegotiateOfferResponse = (
  status: number,
  response: Estimate | null
): RestHandler<MockedRequest<Estimate | null>> => {
  return rest.post(`/client/:clientId/session/:sessionId/offer/negotiate`, (_, res, ctx) => {
    return res(ctx.status(status), ctx.json(response));
  });
};

export const offerHandlers = [
  buildAcceptOfferResponse(200, generateTestEstimate()),
  buildDeclineOfferResponse(200, generateTestEstimate()),
  buildNegotiateOfferResponse(200, generateTestEstimate()),
];
